import useUserPermissionsStore from "../../../../stores/useUserPermissionsStore";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@heroui/react";
import { FiMoreVertical } from "react-icons/fi";
import { Trans } from "@lingui/react/macro";

const AppointmentActions = (props) => {
  const { onClickDelete, updateUserAppointmentAttendance, appointment } = props;

  const permissions = useUserPermissionsStore((state) => state.permissions);

  return (
    <>
      <div className="flex flex-col items-end gap-2">
        <Dropdown>
          <DropdownTrigger>
            <Button isIconOnly size="sm" variant="light">
              <FiMoreVertical className="h-4 w-4" />
            </Button>
          </DropdownTrigger>
          <DropdownMenu>
            {permissions.manage_appointments && (
              <>
                <DropdownItem
                  key={"delete-appointment"}
                  color="danger"
                  onPress={() => {
                    onClickDelete();
                  }}
                >
                  <Trans>Izbriši termin</Trans>
                </DropdownItem>
                <DropdownItem
                  key={"mark-attendance"}
                  color="warning"
                  onPress={() => {
                    const newStatus =
                      appointment.customerDidAttend === 1 ? -1 : 1;
                    updateUserAppointmentAttendance(
                      appointment.userAppointmentId,
                      newStatus,
                    );
                  }}
                >
                  {appointment.customerDidAttend === 1 ? (
                    <Trans>Označi neprihod</Trans>
                  ) : (
                    <Trans>Razveljavi neprihod</Trans>
                  )}
                </DropdownItem>
              </>
            )}
          </DropdownMenu>
        </Dropdown>
      </div>
    </>
  );
};

export default AppointmentActions;
